import { useQuery } from "@tanstack/vue-query"
import type { MaybeRefOrGetter } from "vue"
import type { Licence } from "~/types/licence"

export function useLicences(
  refetchInterval?: MaybeRefOrGetter<number | false>,
) {
  const { isAuthorized } = useAuth()

  const api = useApiClients()

  return useQuery({
    enabled: isAuthorized,
    refetchInterval,
    queryKey: ["licences"],
    queryFn() {
      return api.external<Licence[]>("/rest/frontend/licenses/products", {
        params: {
          site: "KUNNE",
        },
      })
    },
  })
}
